export const constants = { 
    regexPatterns : {
        alphaNumeric: /^[a-zA-Z0-9]+$/
    }
}

export const isValidJSON = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}

export const convertObjectToQueryString = (obj) => {
    return `?${Object.keys(obj)
      .map((key) => `${key}=${obj[key]}`)
      .join("&")}`;
  }